module.exports = __webpack_public_path__ + "static/media/23.00f5171d.jpg";